import { useTranslation } from '@utils/i18n/i18n.consumers';
import { HAZARD_CATEGORIES } from '@App/components/AdaptationListComponent/adaptation-list-component.constants';
import { RISK_DATA_REGIONS } from '@App/pages/RiskDataPage/risk-data';
import TranslatedSelect from '@App/components/TranslatedSelect/TranslatedSelect';

import CollapsibleTrigger from '../CollapsibleTrigger/CollapsibleTrigger';

import './risk-data-tab-layout.styl';

function RiskDataTabLayout({
  collapsibleItems = [],
  openRisk,
  selectedHorizon,
  selectedScenario,
  setOpenRisk,
  isRiskEnabled,
  onRiskEnabledChange,
  setSelectedRisk,
}) {
  const { t } = useTranslation();

  const selectedItem = openRisk
    ? collapsibleItems.find(item => item.risk === openRisk)
    : null;

  return (
    <div className="risk-data-tab-layout ">
      <div className="my-fifth-risk-step">
        {collapsibleItems.map(({ risk }) => {
          const riskInfo = HAZARD_CATEGORIES.find(hazard => hazard.id === risk);
          const enabled = typeof isRiskEnabled === 'function' ? isRiskEnabled(risk) : true;
        
          return (
            <button
              type="button"
              className={`risk-data-tab-layout__category-card ${openRisk === risk ? ' risk-data-tab-layout__category-card--active' : ''}`}
              onClick={() => {
                setOpenRisk(risk);
                setSelectedRisk(risk);
              }}
              key={risk}
            >
              <CollapsibleTrigger
                icon={riskInfo.icon}
                title={t(riskInfo.id)}
                riskValue={RISK_DATA_REGIONS.Kasungu[selectedHorizon.id][selectedScenario.id][risk]}
                open={openRisk === risk}
                riskId={risk}
                enabled={enabled}
                onEnabledChange={onRiskEnabledChange}
              />
            </button>
          );
        })}

        <TranslatedSelect
          options={collapsibleItems.map(({ risk }) => ({
            id: risk,
            label: t(HAZARD_CATEGORIES.find(hazard => hazard.id === risk)?.id || risk),
          }))}
          value={openRisk}
          onInputChange={(e) => {
            setOpenRisk(e?.id || null)
            setSelectedRisk(e?.id || null)
          }}
          css={{
            width: '250px',
            border: 'none',
          }}
          className="risk-data-tab-layout__select"
        />
      </div>
      {selectedItem && (
        <div className="risk-data-tab-layout__content">
          {selectedItem.collapsibleContent}
        </div>
      )}
    </div>
  );
}

export default RiskDataTabLayout;
